import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { StateService } from "common";
import { LoyaltyRewardOffer } from "../models/loyalty-reward.model";

interface LoyaltyRewardState {
  offer: LoyaltyRewardOffer | null;
  loanId: number | null;
}

const initialState: LoyaltyRewardState = { offer: null, loanId: null };

@Injectable({ providedIn: "root" })
export class LoyaltyRewardStateService extends StateService<LoyaltyRewardState> {
  constructor() {
    super(initialState);
  }

  getOffer$(): Observable<LoyaltyRewardOffer | null> {
    return this.select((state) => state?.offer);
  }

  setOffer(offer: LoyaltyRewardOffer | null, loanId: number): void {
    this.setState({ offer, loanId });
  }

  isOfferLoaded(loanId: number): boolean {
    return this.state?.loanId === loanId && this.state?.offer !== null && this.state?.offer !== undefined;
  }

  clearOffer(): void {
    this.initState(initialState);
  }
}
